import { useParams, Navigate } from "react-router-dom";
import { ServiceDetail } from "../components/ServiceDetail";
import { SERVICE_DETAILS } from "../lib/services";

export default function ServiceDetailPage() {
  const { slug } = useParams();
  const data = SERVICE_DETAILS[slug];
  if (!data) return <Navigate to="/services" replace />;
  return <ServiceDetail key={slug} data={data} />;
}
